import { TIME_MS } from '@core-systems/frontend-shared';
import { QueryClient } from '@tanstack/react-query';
import { generateClient } from 'aws-amplify/api';

/**
 * Simple API client for GraphQL requests
 */
const apiClient = generateClient();

/**
 * Configured QueryClient with optimized settings for faster recovery.
 * Static JSON data doesn't need aggressive retries or backoff.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1, // Single retry for faster recovery
      retryDelay: 0, // Immediate retry, no exponential backoff
      refetchOnWindowFocus: false, // Don't refetch on window focus (static data)
      staleTime: 5 * TIME_MS.MINUTE // 5 minutes - good for static/semi-static data
    },
    mutations: {
      retry: false // Don't retry mutations (user actions should be explicit)
    }
  }
});

export default apiClient;
